import React from "react";
// Common Components
import {
  DynamicDropdown,
  TextInput,
  DynamicMultiSelectDropdown,
  StaticMultiSelectDropdown,
  StaticDropdown,
} from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Requests
import { getPortfoMonitoringTable } from "src/Requests/portfoMonitoring";
import { getUsers } from "src/Requests/connections";
// Types
import type {
  IPortfoMonitoringSearchParam,
  PortfoMonitoringReport,
} from "src/Interfaces/portfoMonitoring";

const omsEnumList = [
  { name: "-", id: 2 },
  { name: "صحرا", id: 0 },
  { name: "تدبیر", id: 1 },
  { name: "مجازی", id: 3 },
  { name: "رامند", id: 4 },
];

const PortfoMonitoring: React.FC = () => {
  const [searchParam, setSearchParam] =
    React.useState<IPortfoMonitoringSearchParam>(
      {} as IPortfoMonitoringSearchParam
    );

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParam({
      ...searchParam,
      [name]: value,
    });
  };

  React.useEffect(() => {
    if (searchParam?.sahraUserIds?.length === 0) {
      delete searchParam.sahraUserIds;
    }
    if (searchParam.omsEnum === null) {
      delete searchParam.omsEnum;
    }
  }, [searchParam]);

  return (
    <div className="p-7">
      <div className="flex items-center justify-between gap-6">
        <div className="w-1/5">
          <DynamicMultiSelectDropdown
            dropdown={{
              name: "sahraUserIds",
              placeholder: "کاربران",
              extraLabel: true,
            }}
            getData={getUsers}
            onChange={searchParamChangeHandler}
            value={searchParam?.sahraUserIds}
          />
        </div>
        <div className="w-1/5">
          <StaticDropdown
            dropdown={{
              name: "omsEnum",
              placeholder: "oms",
              extraLabel: true,
            }}
            options={omsEnumList}
            onChange={searchParamChangeHandler}
            value={searchParam?.omsEnum}
          />
        </div>
        <div className="w-1/5">
          <TextInput
            name="increaseTime"
            label="زمان افزایش"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.increaseTime || ""}
          />
        </div>
      </div>
      <TableTemplate<IPortfoMonitoringSearchParam, PortfoMonitoringReport>
        getDataTable={getPortfoMonitoringTable}
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            tableBoxClassName="!mx-0"
          />
        )}
        withSort
        searchParameters={searchParam}
      />
    </div>
  );
};

export default PortfoMonitoring;
